import React from 'react';
import { Card as MuiCard, CardContent, Typography, Box, Rating, Button } from "@mui/material";
import { saveContact } from "../../api/actions/mutation";
const Card = ({ business , index, messageShow }) => {
    const onSaveContact = async () => {
        try {
            business.type = "Yelp"
            const { data } = await saveContact(business)
            if (data.success) {
                messageShow(data.message);
            } else {
                messageShow(data.message);
            }
        } catch (error) {
            messageShow("An error occurred. Please try again.");
        }
    };

    return (
        <MuiCard sx={{ width: 300, height: '100%', display: "flex", flexDirection: "column", justifyContent: "space-between", }}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    {index+1}. {business.name}
                </Typography>

                <Box display="flex" alignItems="center" mb={1}>
                    <Rating 
                        value={business.rating} 
                        readOnly 
                        precision={0.5}
                    />
                    <Typography variant="body2" ml={1}>
                        ({business.review_count} reviews)
                    </Typography>
                </Box>

                <Typography color="textSecondary" gutterBottom>
                {business.categories.map((cat) => cat.title).join(', ')}
                </Typography>

                <Typography variant="body2">
                    {business.location.address1}<br />
                    {business.location.city}, {business.location.state} {business.location.zip_code}
                </Typography>

                <Typography variant="body2" mt={1}>
                    {business.display_phone}
                </Typography>
            </CardContent>
            <Box sx={{ p: 2, textAlign: "center" }}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={onSaveContact}
                >
                    Save
                </Button>
            </Box>
        </MuiCard>
    );
};

export default Card;
